(() => {
const init = root => {
if (!root || root.dataset.rsReady) return;
root.dataset.rsReady = 'true';
const form = root.querySelector('#RatnayaStoryContact');
const select = root.querySelector('#rs-interest');
const target = root.querySelector('#rs-enquiry');
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
root.querySelectorAll('[data-rs-interest]').forEach(link => link.addEventListener('click', event => {
if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0 || !select) return;
event.preventDefault();
select.value = link.dataset.rsInterest;
select.dispatchEvent(new Event('change', {bubbles:true}));
target.scrollIntoView({behavior:reduced.matches ? 'auto' : 'smooth',block:'start'});
}));
root.querySelectorAll('a[href="#rs-enquiry"]:not([data-rs-interest])').forEach(link => link.addEventListener('click', event => {
if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
event.preventDefault();
target.scrollIntoView({behavior:reduced.matches ? 'auto' : 'smooth',block:'start'});
}));
if ('IntersectionObserver' in window) {
const sticky = root.querySelector('[data-rs-sticky]');
const observer = new IntersectionObserver(entries => {
for (const entry of entries) if (sticky) sticky.hidden = target.getBoundingClientRect().top < innerHeight || root.querySelector('.rs-hero').getBoundingClientRect().bottom > 0;
},{threshold:0});
observer.observe(target);
observer.observe(root.querySelector('.rs-hero'));
const reveal = new IntersectionObserver(entries => {
for(const entry of entries) if(entry.isIntersecting) {entry.target.classList.remove('rs-before');reveal.unobserve(entry.target);}
},{rootMargin:'0px 0px -30px 0px',threshold:0.05});
root.classList.add('rs-ready');
root.querySelectorAll('.rs-reveal').forEach(el => {el.classList.add('rs-before');reveal.observe(el);});
}
const status = form?.querySelector('.rs-success, .rs-errors');
if(status) {status.focus({preventScroll:true});status.scrollIntoView({block:'center'});}
};
document.querySelectorAll('[data-rs-story]').forEach(init);
document.addEventListener('shopify:section:load',event => init(event.target.querySelector('[data-rs-story]')));
})();
